<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'필수 정보 입력'"
      :modal="true"
      :width="'500px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div>
      <ul class="filter_list w100">
        <li>
          <label class="w30">수신 시간<span class="forg">*</span></label>
          <ul class="w70">
            <li>
              <div v-for="item in ampmScnList">
                <input
                    class="k-radio"
                    type="radio"
                    name="receiveAmpmScn"
                    :id="`R${item.cdId}_1`"
                    :value="item.cdId"
                    @change="pouchInfo.receiveAmpmScn = item.cdId"
                    :checked="item.cdId === pouchInfo.receiveAmpmScn">
                <label :for="`R${item.cdId}_1`" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="button_area w30">
      <ul>
        <li class="w50"><button class="large_btn" @click="onCloseWindow">취소</button></li>
        <li class="w50"><button class="large_btn orange ml5" @click="getReceiveInfo">저장</button></li>
      </ul>
    </div>

  </kendo-window>
</template>

<script>
import {LogisticsCodeDtlMixin} from "@/mixin/Mixin";

export default {
  name: "GetReceiveInfo",
  mixins: [LogisticsCodeDtlMixin],
  props: {
    propsPouchInfo : {
      type : Object,
      required : true,
      default : function (){
        return {}
      }
    }
  },
  methods: {
    onOpenWindow () {
      const vm = this
      vm.pouchInfo = vm.propsPouchInfo
    },
    getReceiveInfo () {
      const vm = this
      if (!!!vm.pouchInfo.receiveAmpmScn) {
        kendo.alert('수신 시간을 선택해주세요.')
        return false
      }
      vm.$emit('getReceiveInfo', {
        receiveAmpmScn : vm.pouchInfo.receiveAmpmScn
      })
    },
    onCloseWindow () {
      const vm = this
      vm.$refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    return {
      pouchInfo: {},
    }
  }
}
</script>

<style scoped>

</style>